import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAlert,{attrs:{"prominent":"","type":"error"}},[_c(VRow,{attrs:{"align":"center"}},[_c(VCol,{staticClass:"grow"},[_vm._v(" "+_vm._s(_vm.value.message)+" ")]),_c(VCol,{staticClass:"shrink"},[_c(VBtn,{attrs:{"text":""},on:{"click":function($event){return _vm.$emit('retry')}}},[_vm._v(_vm._s(_vm.retryText || 'Retry'))])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }